/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FitAndProperCheckViewModel } from './FitAndProperCheckViewModel';
import {
    FitAndProperCheckViewModelFromJSON,
    FitAndProperCheckViewModelFromJSONTyped,
    FitAndProperCheckViewModelToJSON,
} from './FitAndProperCheckViewModel';

/**
 * 
 * @export
 * @interface InvestmentDetailsCommissionSplitViewModel
 */
export interface InvestmentDetailsCommissionSplitViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsCommissionSplitViewModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestmentDetailsCommissionSplitViewModel
     */
    intermediaryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentDetailsCommissionSplitViewModel
     */
    intermediaryNameAndSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentDetailsCommissionSplitViewModel
     */
    pRINumber?: string;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsCommissionSplitViewModel
     */
    bankBrokerApplicationNumber?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InvestmentDetailsCommissionSplitViewModel
     */
    isAdvisingIntermediary?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvestmentDetailsCommissionSplitViewModel
     */
    isServicingIntermediary?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsCommissionSplitViewModel
     */
    annualFeeSplitPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsCommissionSplitViewModel
     */
    recurringFeeSplitPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsCommissionSplitViewModel
     */
    commissionSplitPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsCommissionSplitViewModel
     */
    lumpSumFeeSplitPercentage?: number;
    /**
     * 
     * @type {FitAndProperCheckViewModel}
     * @memberof InvestmentDetailsCommissionSplitViewModel
     */
    fitAndProperCheck?: FitAndProperCheckViewModel;
}

/**
 * Check if a given object implements the InvestmentDetailsCommissionSplitViewModel interface.
 */
export function instanceOfInvestmentDetailsCommissionSplitViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InvestmentDetailsCommissionSplitViewModelFromJSON(json: any): InvestmentDetailsCommissionSplitViewModel {
    return InvestmentDetailsCommissionSplitViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsCommissionSplitViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsCommissionSplitViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'intermediaryCode': !exists(json, 'IntermediaryCode') ? undefined : json['IntermediaryCode'],
        'intermediaryNameAndSurname': !exists(json, 'IntermediaryNameAndSurname') ? undefined : json['IntermediaryNameAndSurname'],
        'pRINumber': !exists(json, 'PRINumber') ? undefined : json['PRINumber'],
        'bankBrokerApplicationNumber': !exists(json, 'BankBrokerApplicationNumber') ? undefined : json['BankBrokerApplicationNumber'],
        'isAdvisingIntermediary': !exists(json, 'IsAdvisingIntermediary') ? undefined : json['IsAdvisingIntermediary'],
        'isServicingIntermediary': !exists(json, 'IsServicingIntermediary') ? undefined : json['IsServicingIntermediary'],
        'annualFeeSplitPercentage': !exists(json, 'AnnualFeeSplitPercentage') ? undefined : json['AnnualFeeSplitPercentage'],
        'recurringFeeSplitPercentage': !exists(json, 'RecurringFeeSplitPercentage') ? undefined : json['RecurringFeeSplitPercentage'],
        'commissionSplitPercentage': !exists(json, 'CommissionSplitPercentage') ? undefined : json['CommissionSplitPercentage'],
        'lumpSumFeeSplitPercentage': !exists(json, 'LumpSumFeeSplitPercentage') ? undefined : json['LumpSumFeeSplitPercentage'],
        'fitAndProperCheck': !exists(json, 'FitAndProperCheck') ? undefined : FitAndProperCheckViewModelFromJSON(json['FitAndProperCheck']),
    };
}

export function InvestmentDetailsCommissionSplitViewModelToJSON(value?: InvestmentDetailsCommissionSplitViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'IntermediaryCode': value.intermediaryCode,
        'IntermediaryNameAndSurname': value.intermediaryNameAndSurname,
        'PRINumber': value.pRINumber,
        'BankBrokerApplicationNumber': value.bankBrokerApplicationNumber,
        'IsAdvisingIntermediary': value.isAdvisingIntermediary,
        'IsServicingIntermediary': value.isServicingIntermediary,
        'AnnualFeeSplitPercentage': value.annualFeeSplitPercentage,
        'RecurringFeeSplitPercentage': value.recurringFeeSplitPercentage,
        'CommissionSplitPercentage': value.commissionSplitPercentage,
        'LumpSumFeeSplitPercentage': value.lumpSumFeeSplitPercentage,
        'FitAndProperCheck': FitAndProperCheckViewModelToJSON(value.fitAndProperCheck),
    };
}

